import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  template:
  `
  <p>
 You are not authorized to access this system.
</p>
<p>Please Login</p>
`
  
 
})
export class UnauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
